export const TRANSACTION_DETAILS_TABS = {
  documents: 'documents',
  data: 'data',
  stream: 'stream',
  type: 'type',
} as const;
